export const WEBSITE_MODULE = {
  ACTION_TYPES: {
    usPopup: 'usPopup',
    userSelectionToaster: 'userSelectionToaster',
    wizardWidgetAutoDisplayHandler: 'wizardWidgetAutoDisplayHandler',
    didomiWidgetAutoDisplayHandler: 'didomiWidgetAutoDisplayHandler',
    onToggleDrawer: 'onToggleDrawer',
    onMainScreenRendered: 'onMainScreenRendered',
    onRouteChange: 'onRouteChange',
    webTopAppCTAVisibleHandler: 'webTopAppCTAVisibleHandler',
    copper6DisplayHandler: 'copper6DisplayHandler',
    fetchMetadata: 'fetchMetadata',
    stickyExternalAdDisplayHandler: 'stickyExternalAdDisplayHandler'
  },
  ANALYTICS: {
    CLICK_TYPES: {
      yes: 'yes',
      no: 'no'
    }
  },
  GOOGLE_ANALYTICS: {
    EVENTS: {
      display: 'web_us-edition-popup_display',
      click: 'web_us-edition-popup_click',
      externalAdDisplay: 'layout_ads_display',
      externalAdClick: 'ad_interaction'
    }
  },
    US_USER_COUNTRY: 18,
  US_LANGUAGE_ID: 9,
  DEFAULT_LANGUAGE_ID: 1,

  HREF_CULTURE_NAME_LANG_ID: {
    EnglishUK: 10
  }
}

export const SCORES_CONTEXT = {
  scoresBar: 'scoresBar'
}

export const DISPLAY_CONSTS = {
  SIDE_BAR_WIDTHS: {
    small: 320,
    medium: 400,
    large: 480
  },
  MAIN_CONTENT_WIDTHS: {
    small: {
      min: 432,
      max: 687
    },
    medium: {
      min: 592,
      max: 791
    },
    large: {
      min: 592,
      max: 728
    }
  },
}

export const SOCIAL_TAGS = {
  og: 'og',
  twitter: 'twitter'
}

